export const formatScope = (roles = [], regions = [], areas = []) => {
  if (!Array.isArray(roles)) return [];

  return roles.map(role => {
    const scope = role?.regionIds;
    if (!Array.isArray(scope) || scope.length === 0) {
      return {
        roleName: role.name,
        scopeDetails: [],
      };
    }

    const scopeDetails = scope.map(sc => {
      const regionName = regions.find(r => r.id === sc.regionId)?.name || `Region ${sc.regionId}`;
      const areaNames = (sc.areas || [])
        .map(areaId => areas.find(a => a.id === areaId)?.name || `Area ${areaId}`)
        .join(', ');
      return { regionName, areaNames };
    });

    return {
      roleName: role.name,
      scopeDetails,
    };
  });
};